import { API } from "../../../utils";

export const getAllProducts = async (params) => {  
  const res = await API.get("variant_product/list", params);
  return res.data;
};

export const createGrid = async (payload) => {
  const res = await API.post("keypads", payload);
  return res.data;
};

export const updateGrid = async (payload, id) => {
  const res = await API.put(`keypads/${id}`, payload);
  return res.data;
};

export const getDetails = async (id) => {
  const res = await API.get(`keypads/${id}`);
  return res.data;
};
